import { useEffect, useState } from 'react'
import { useSelector } from 'store/redux.store'
import sparkie, { subscribeEvents } from 'utils/sparkie'
import request from '@hotmart/request'
import { CHAT_REQUEST_IDENTIFIERS } from 'modules/chat'
import { LOCALSTORAGE_TOKEN_NAME } from 'src/modules/auth/auth.constants'
import { useDispatch } from 'react-redux'
import { userSlice } from 'src/modules/user'
import { IChatNotification } from './use-chat-notification.interface'

export const useChatNotification = (): IChatNotification => {
  const localToken = localStorage.getItem(LOCALSTORAGE_TOKEN_NAME)
  const auth = useSelector(state => state.auth)
  const user = useSelector(state => state.user)
  const dispatch = useDispatch()
  const [unreadMessagesCounter, setUnreadMessagesCounter] = useState(0)

  const hasToken = Boolean(auth || localToken)
  const hasChatContactId = Boolean(user.contactId)

  useEffect(() => {
    const fetchChatContactId = async () => {
      try {
        const { id: contactId } = await request(CHAT_REQUEST_IDENTIFIERS.USER_ME)

        dispatch(userSlice.actions.updateUser({ contactId }))
      } catch (error) {
        console.error('BW: Failed fetching chat contact id', error)
      }
    }

    fetchChatContactId()
  }, [])

  const fetchUnreadMessages = async () => {
    const newMessages = await request(CHAT_REQUEST_IDENTIFIERS.UNREAD_MESSAGES)

    setUnreadMessagesCounter(newMessages)
  }

  const sparkieEventCursorHandler = cursor => {
    if (user?.contactId === cursor.contactId) {
      fetchUnreadMessages()
    }
  }

  const sparkieEventMessageHandler = () => {
    fetchUnreadMessages()
  }

  useEffect(() => {
    if (hasToken && hasChatContactId) {
      sparkie.init(auth ? auth.hmVlcIntegration : localToken).then(() => {
        subscribeEvents({
          cursorUpdated: sparkieEventCursorHandler,
          messageReceived: sparkieEventMessageHandler
        })

        fetchUnreadMessages()
      })
    }
  }, [auth, localToken, user])

  return {
    unreadMessagesCounter
  }
}
